import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

function Receipt(props) {
    const { activeReceipt, MemberData, FamilyGroupData, setReceiptRendering } = props;
    const [loaded, setLoaded] = useState(false);
    const legalData = MemberData.grupo_familiar === activeReceipt.socio.substr(3) ? FamilyGroupData : MemberData;

    useEffect(() => {
        downloadPdf();
    })

    const downloadPdf = () => {
        const input = document.getElementById('receipt');
        if (input) {
            html2canvas(input, {
                scale: 1.3,
                useCORS: true,
            }).then(canvas => {
                const imgData = canvas.toDataURL('image/png'),
                    pdf = new jsPDF({
                        orientation: 'portrait',
                        unit: 'mm',
                        format: 'a4'
                    }),
                    margin = 10,
                    pdfWidth = pdf.internal.pageSize.getWidth(),
                    imgWidth = pdfWidth - (margin * 2),
                    imgHeight = (canvas.height * imgWidth) / canvas.width;
                pdf.addImage(imgData, 'PNG', margin, margin, imgWidth, imgHeight);
                const fileName = `AGR-recibo-${activeReceipt.recibo}-${legalData.documentonumero.length < 15 ? legalData.documentonumero : ('GrupoFamiliar' + legalData.apellido)}.pdf`;
                pdf.save(fileName);
                const pdfBlob = pdf.output('blob');
                const file = new File([pdfBlob], fileName, { type: 'application/pdf' });

                if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
                    navigator.share({
                        files: [file],
                        title: `Recibo AGR ${activeReceipt.recibo}`,
                        text: `Recibo de pago de Alta Gracia Rugby para ${legalData.apellido}, ${legalData.nombre}.`,
                    })
                        .catch((error) => {
                            if (error.name !== 'AbortError')
                                console.error('Error sharing:', error);

                        })
                        .finally(() => setReceiptRendering({ render: false }));
                } else {
                    setReceiptRendering({ render: false });
                }
            });
        }
    };

    useEffect(() => {
        setLoaded(Object.keys(activeReceipt).includes('recibo'));
    }, [activeReceipt]);

    const localizedMoney = (num) => {
        const format = new Intl.NumberFormat('es-ES', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: true
        });
        return format.format(num);
    }

    const toFixed18 = (num) => {
        let pre = Number(num).toFixed(2).replaceAll('.', '');
        while (pre.length < 18) pre = '0' + pre;
        return `*${pre}*`;
    }

    const shortDate = date => {
        if (!date || typeof date !== 'string' || date.length < 10) return '';
        const [year, month, day] = date.substring(0, 10).split('-');
        const months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
        return `${day} ${months[Number(month) - 1]} ${year}`;
    }

    const longDate = date => {
        if (!date || typeof date !== 'string' || date.length < 10) return '';
        const [year, month, day] = date.substring(0, 10).split('-');
        const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        return `${day} de ${months[Number(month) - 1]} de ${year}`;
    }


    return loaded ? (
        <Box
            id='receipt'
            sx={{
                fontSize: '3mm', width: '250mm',
                margin: 'auto',
                fontFamily: 'Noto Serif', display: 'grid', gridTemplateColumns: '35% auto 18mm', gap: '1mm',
                '& h1': { margin: 0, fontSize: '3mm', fontFamily: 'Noto Sans', fontWeight: 'bold', letterSpacing: '0.2em', },
                '& .data': { fontFamily: 'Noto Sans', fontWeight: 'bold', letterSpacing: '0.2em', },
            }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: '.2em', padding: '1mm 3mm', border: 'solid 1px black', }}>
                <Box>
                    <Box sx={{ float: 'right', border: 'solid 1px black', padding: '.5em', backgroundColor: 'white', fontFamily: 'Noto Sans', fontWeight: 'bold', }}>$ {localizedMoney(activeReceipt.Monto)}</Box>
                    <h1>ALTA GRACIA RUGBY</h1>
                    <Box>Socio N°: <span className='data'>{legalData.socio}</span></Box>
                    <Box>Nombre: <span className='data'>{legalData.apellido}, {legalData.nombre}</span></Box>
                    <Box>DNI: <span className='data'>{legalData.documentonumero}</span></Box>
                    <Box sx={{ textAlign: 'center', padding: '.5em' }}>ALTA GRACIA</Box>
                    <Box sx={{ display: 'flex', gap: '.2em', margin: '0 auto', width: 'fit-content', }}>Concepto:<Box sx={{ fontFamily: 'Noto Sans', whiteSpace: 'pre', }}>{activeReceipt.DetEstado}</Box></Box>
                </Box>
                <Box>
                    <span>{longDate(activeReceipt.Fecha)}</span>
                    <Box sx={{ fontSize: '3.9mm', lineHeight: '1.5', position: 'relative', fontFamily: 'Noto Sans', fontWeight: 'bold', letterSpacing: '0.2em', }}>
                        <Box>{toFixed18(activeReceipt.Monto)}</Box>
                        <Box sx={{ fontSize: '.5em', position: 'absolute', bottom: 0, left: 0, letterSpacing: '0.2em', }}>{toFixed18(activeReceipt.Monto)}</Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: '.2em', justifyContent: 'space-between', }}>
                        <span>N° <span className='data'>{activeReceipt.recibo}</span></span>
                        <Box sx={{ opacity: .75 }}>Duplicado para Control</Box>
                    </Box>
                </Box>
            </Box>
            <Box sx={{
                display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: '.2em', padding: '1mm 3mm', border: 'solid 1px black', '& h1': { borderBottom: 'solid 2px black', }
            }}>
                <Box>
                    <Box sx={{ float: 'right', border: 'solid 1px black', padding: '.5em', backgroundColor: 'white', fontFamily: 'Noto Sans', fontWeight: 'bold', }}>$ {localizedMoney(activeReceipt.Monto)}</Box>
                    <h1>ALTA GRACIA RUGBY</h1>
                    <Box>Socio N°: <span className='data'>{legalData.socio}</span></Box>
                    <Box>Nombre: <span className='data'>{legalData.apellido}, {legalData.nombre}</span></Box>
                    <Box>DNI: <span className='data'>{legalData.documentonumero}</span></Box>
                    <Box sx={{ textAlign: 'center', padding: '.5em' }} className='data'>{legalData.direccion}<br />{legalData.ciudad}{(!!legalData.ciudad && !!legalData.codpostal) ? ' - ' : ''}{legalData.codpostal}</Box>
                    <Box sx={{ display: 'flex', gap: '.2em', margin: '0 auto', width: 'fit-content', }}>
                        Concepto:
                        <Box sx={{ fontFamily: 'Noto Sans', whiteSpace: 'pre', }}>{activeReceipt.DetEstado}</Box></Box>
                </Box>
                <Box>
                    <span>{longDate(activeReceipt.Fecha)}</span>
                    <Box sx={{ fontSize: '3.9mm', lineHeight: '1.5', position: 'relative', fontFamily: 'Noto Sans', fontWeight: 'bold', letterSpacing: '0.2em', }}>
                        <Box>{toFixed18(activeReceipt.Monto)}</Box>
                        <Box sx={{ fontSize: '.5em', position: 'absolute', bottom: 0, left: 0, letterSpacing: '0.2em', }}>{toFixed18(activeReceipt.Monto)}</Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: '.2em', justifyContent: 'space-between', }}>
                        <Box sx={{ opacity: .75 }}>Original para el Socio</Box>
                        <span>Recibo N° <span className='data'>{activeReceipt.recibo}</span></span>
                        <Box sx={{ borderTop: 'solid 1px black', minWidth: '2.5cm', textAlign: 'center', }}>Tesorero</Box>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ width: '18mm', minHeight: '53mm', position: 'relative', padding: '1mm 3mm', border: 'solid 1px black', }}>
                <Box sx={{ height: '18mm', width: '53mm', transform: 'translate(-50%, -50%) rotate(270deg)', transformOrigin: 'center', position: 'absolute', top: '50%', left: '50%', textAlign: 'center', lineHeight: 1.2, fontSize: '2.4mm', padding: '.5mm', gap: 0, }}>
                    <h1>ALTA GRACIA RUGBY</h1>
                    <Box sx={{ display: 'flex', gap: '.2em', justifyContent: 'space-evenly', }}>
                        <Box>{shortDate(activeReceipt.Fecha)}</Box>
                        <Box className='data'>{legalData.socio}</Box>
                        <Box sx={{ fontFamily: 'Noto Sans', fontWeight: 'bold', }}>$ {localizedMoney(activeReceipt.Monto)}</Box>
                    </Box>
                    <Box className='data'>{legalData.apellido}, {legalData.nombre} {legalData.documentonumero.length < 15 ? legalData.documentonumero : ''}</Box>
                    <Box>Concepto: <span className='data'>{activeReceipt.Concepto}</span></Box>
                    <Box sx={{ display: 'flex', gap: '.2em', justifyContent: 'space-evenly', }}>
                        <Box />
                        <Box>Recibo N° <span className='data'>{activeReceipt.recibo}</span></Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    ) : (<></>)
}
export default Receipt;
